// extracted by mini-css-extract-plugin
module.exports = {"events":"style_events__peU2r","text":"style_text__mWNBR","nation":"style_nation__jmEzx","title":"style_title__XBFqI"};